var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-segmented',{staticClass:"chart-period-selector",class:{ 'chart-period-selector--compact': _vm.isCompact },attrs:{"value":_vm.value,"options":_vm.options},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }